import { useQuery } from "@tanstack/react-query";
import { RecipeLayer } from "../../models/RecipeLayer";
import { getRecipeLayers } from "../../repositories/RecipeRepository";

export const useRecipeLayersQuery = (
  recipeId: number | null | undefined,
  chargeNumber: number | null | undefined,
) => {
  return useQuery({
    queryKey: ["recipe-layers", recipeId, chargeNumber],
    meta: { realtime: ["SCRAP.GetRecipeLayers"] },
    queryFn: async ({ signal }) => {
      const resp = await getRecipeLayers(recipeId!, chargeNumber!, signal);
      if (resp.ok) {
        return (resp.data?.tables?.[0]?.rows ?? []) as RecipeLayer[];
      }
      throw new Error(resp.message);
    },
    enabled: !!recipeId && !!chargeNumber,
  });
};
